import { call, put, takeEvery } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, ME, LOGOUT_USER } from "../auth/actionTypes";
import { me, loginSuccess, logoutSuccess, authRequestFailed } from "../auth/actions";

import {
  postLogin,
  getMe,
  postLogout,
} from "../../helpers/backend";
import axiosApi from "../../helpers/api";

function* loginUserSaga({ payload: { user, history } }) {
  try {
    const response = yield call(postLogin, user);

    
    if (response.status === 200) {

      localStorage.setItem('token', response.data.access);
      axiosApi.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;

      // Guardar la sesión activa con un identificador único
      localStorage.setItem("session_active", JSON.stringify({ isActive: true, tabId: sessionStorage.getItem("tabId") }));

     
      yield put(me(history));
    } else {
      
      yield put(authRequestFailed(response.data));
    }
  } catch (error) {


    // Mejorar el manejo de errores considerando el interceptor
    let errorPayload = {
      detail: "Error de conexión. Por favor, intenta nuevamente.",
      type: "CONNECTION_ERROR"
    };

    // Verificar si es un error procesado por el interceptor
    if (error.isNetworkError) {
      console.error("🌐 [LOGIN SAGA] Error de red detectado por interceptor");
      errorPayload = {
        detail: "No se pudo conectar con el servidor. Verifica tu conexión a internet.",
        type: "NETWORK_ERROR"
      };
    } else if (error.isSessionExpired) {
      console.error("⏰ [LOGIN SAGA] Sesión expirada detectada por interceptor");
      errorPayload = {
        detail: "La sesión ha expirado. Por favor, inicia sesión nuevamente.",
        type: "SESSION_EXPIRED"
      };
    } else if (error.status || error.response?.status) {
      // Error de respuesta del servidor
      const status = error.status || error.response?.status;
      const serverData = error.data || error.response?.data;
      
      console.error("🔴 [LOGIN SAGA] Error de respuesta del servidor:", {
        status: status,
        serverData: serverData
      });
      
      // Usar los datos del servidor si están disponibles
      if (serverData && typeof serverData === 'object') {
        errorPayload = {
          ...serverData,
          status: status,
          type: "SERVER_ERROR"
        };
      } else {
        // Mensajes específicos según el código de estado
        switch (status) {
          case 400:
            errorPayload = {
              detail: serverData?.detail || "Credenciales inválidas. Verifica tu usuario y contraseña.",
              type: "INVALID_CREDENTIALS",
              status: status
            };
            break;
          case 401:
            errorPayload = {
              detail: serverData?.detail || "Usuario o contraseña incorrectos.",
              type: "UNAUTHORIZED",
              status: status
            };
            break;
          case 403:
            errorPayload = {
              detail: serverData?.detail || "No tienes permisos para acceder.",
              type: "FORBIDDEN",
              status: status
            };
            break;
          case 500:
            errorPayload = {
              detail: serverData?.detail || "Error interno del servidor. Intenta más tarde.",
              type: "SERVER_ERROR",
              status: status
            };
            break;
          default:
            errorPayload = {
              detail: serverData?.detail || `Error del servidor (${status}). Intenta nuevamente.`,
              type: "SERVER_ERROR",
              status: status
            };
        }
      }
    }

    console.error("📤 [LOGIN SAGA] Enviando error al reducer:", errorPayload);
    yield put(authRequestFailed(errorPayload));
  }
}


function* meSaga({ payload: { history } }) {
  try { 
    console.log("👤 [ME SAGA] Obteniendo información del usuario autenticado");
    
    const response = yield call(getMe);  


    if (response.status === 200) {
      let user = {
        id: response.data.id,        
        username: response.data.username,
        password: response.data.password,
        get_full_name: response.data.get_full_name,
        groups: response.data.grupos,
        user_permissions: response.data.user_permissions,
        roles:response.data.roles,     
        status:response.data.status,
        contact:response.data.contact,
      };
      


      localStorage.setItem("user", JSON.stringify(user));
      yield put(loginSuccess(response.data));
      
      if (history.location.pathname === "/login") {
        console.log("🔄 [ME SAGA] Redirigiendo al dashboard");
        history.push("/dashboard");
      } else {
        console.log("📍 [ME SAGA] Usuario ya en:", history.location.pathname);
      }

    } else {
      console.error("❌ [ME SAGA] Error al obtener datos del usuario - Status:", response.status);
      yield put(authRequestFailed(response.data));
    }
  } catch (error) {


    // Mejorar el manejo de errores
    let errorPayload = {
      detail: "Error al obtener información del usuario.",
      type: "USER_DATA_ERROR"
    };

    if (error.response) {
      console.error("🔴 [ME SAGA] Error de respuesta del servidor:", error.response.status);
      errorPayload = {
        ...error.response.data,
        status: error.response.status,
        type: "SERVER_ERROR"
      };
    } else if (error.request) {
      console.error("🌐 [ME SAGA] Error de red - sin respuesta del servidor");
      errorPayload = {
        detail: "No se pudo conectar con el servidor para obtener los datos del usuario.",
        type: "NETWORK_ERROR"
      };
    }

    yield put(authRequestFailed(errorPayload));
  }
}

function* logoutUserSaga({ payload: { history } }) {
  try {
    console.log("🚪 [LOGOUT SAGA] Iniciando proceso de logout");
    
    const response = yield call(postLogout);
    console.log("🚪 [LOGOUT SAGA] Respuesta del servidor:", {
      status: response.status,
      message: "Logout procesado"
    });

    if (response.status === 205) {
      console.log("✅ [LOGOUT SAGA] Logout exitoso, limpiando datos locales");
      
      localStorage.removeItem("user");
      localStorage.removeItem("session_active");
      localStorage.removeItem("token");
      localStorage.removeItem("sessionTime");
      
      // Limpiar headers de autorización
      delete axiosApi.defaults.headers.common['Authorization'];
      
      yield put(logoutSuccess());
      
      console.log("🔄 [LOGOUT SAGA] Redirigiendo al login");
      history.push("/login");
    } else {
      console.error("❌ [LOGOUT SAGA] Error en logout - Status:", response.status);
      yield put(authRequestFailed(response.data));
    }
  } catch (error) {


    // Mejorar el manejo de errores
    let errorPayload = {
      detail: "Error al cerrar sesión.",
      type: "LOGOUT_ERROR"
    };

    if (error.response) {
      console.error("🔴 [LOGOUT SAGA] Error de respuesta del servidor:", error.response.status);
      errorPayload = {
        ...error.response.data,
        status: error.response.status,
        type: "SERVER_ERROR"
      };
    } else if (error.request) {
      console.error("🌐 [LOGOUT SAGA] Error de red - sin respuesta del servidor");
      errorPayload = {
        detail: "No se pudo conectar con el servidor para cerrar sesión.",
        type: "NETWORK_ERROR"
      };
    }

    // Aunque haya error, limpiar datos locales por seguridad
    console.log("🧹 [LOGOUT SAGA] Limpiando datos locales por seguridad");
    localStorage.removeItem("user");
    localStorage.removeItem("session_active");
    localStorage.removeItem("token");
    localStorage.removeItem("sessionTime");
    delete axiosApi.defaults.headers.common['Authorization'];

    yield put(authRequestFailed(errorPayload));
    history.push("/login");
  }
}

export default function* authSaga() {
  console.log("🚀 [AUTH SAGA] Saga de autenticación inicializado");
  yield takeEvery(LOGIN_USER, loginUserSaga);
  yield takeEvery(ME, meSaga);
  yield takeEvery(LOGOUT_USER, logoutUserSaga);
}